/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Fund_ConfirmingInputs */

const en_onboarding_v1_fund_confirming = /** @type {(inputs: Onboarding_V1_Fund_ConfirmingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirming deposit…`)
};

const de_onboarding_v1_fund_confirming = /** @type {(inputs: Onboarding_V1_Fund_ConfirmingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einzahlung wird bestätigt…`)
};

const pt_br2_onboarding_v1_fund_confirming = /** @type {(inputs: Onboarding_V1_Fund_ConfirmingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmando depósito…`)
};

const tr_onboarding_v1_fund_confirming = /** @type {(inputs: Onboarding_V1_Fund_ConfirmingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yatırma işlemi onaylanıyor…`)
};

const zh_cn2_onboarding_v1_fund_confirming = /** @type {(inputs: Onboarding_V1_Fund_ConfirmingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在确认存款…`)
};

const zh_hk2_onboarding_v1_fund_confirming = /** @type {(inputs: Onboarding_V1_Fund_ConfirmingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在確認存款…`)
};

const ko_kr2_onboarding_v1_fund_confirming = /** @type {(inputs: Onboarding_V1_Fund_ConfirmingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`입금을 확인하는 중…`)
};

const ru_ru2_onboarding_v1_fund_confirming = /** @type {(inputs: Onboarding_V1_Fund_ConfirmingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подтверждаем пополнение…`)
};

const es_419_onboarding_v1_fund_confirming = /** @type {(inputs: Onboarding_V1_Fund_ConfirmingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmando depósito…`)
};

/**
* | output |
* | --- |
* | "Confirming deposit…" |
*
* @param {Onboarding_V1_Fund_ConfirmingInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_fund_confirming = /** @type {((inputs?: Onboarding_V1_Fund_ConfirmingInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Fund_ConfirmingInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_fund_confirming(inputs)
	if (locale === "de") return de_onboarding_v1_fund_confirming(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_fund_confirming(inputs)
	if (locale === "tr") return tr_onboarding_v1_fund_confirming(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_fund_confirming(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_fund_confirming(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_fund_confirming(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_fund_confirming(inputs)
	return es_419_onboarding_v1_fund_confirming(inputs)
});